import React, {useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {useBasketStore, useContentStore} from '../../../../store/hooks/useStore'
import {Stack, Text} from '../../../../vanilla'
import {BasketIcon} from '../../../icons'
import {CartItem} from '../../../cart-item'
import {cartItemDrawer} from '../styles.css'
import {Slot} from '../../../cms/Slot'
import {useItemsUnavailable} from '../../../../store/hooks/useItemsUnavailable'
import {FreeGift} from '../../../../pages/cart/partials/free-gift'
import {ProductItem} from '../../../../store/BasketStore'
import {UnavailableCartItems} from '../../../../pages/cart/partials/unavailable-cart-items'
import {MealDealCartItem} from '../../../cart-item/meal-deal-cart-item'
import {MealDealGroup} from '../../../../types/store/basket'

const GLOBAL_MINI_CART_CONTENT_SLOT = 'global/mini-cart'

export const DrawerCartItems = observer(() => {
  const basketStore = useBasketStore()

  const cms = useContentStore()
  const someItemsUnavailable = useItemsUnavailable()
  const {groupedBonusItems, basket, displayMealDealAsGroup} = useBasketStore()

  const mealDealGroups = basket?.mealdeals

  const displayMealDealGroups =
    displayMealDealAsGroup === true &&
    (mealDealGroups?.groupedItems?.length || mealDealGroups?.ungroupedItems?.length) > 0

  const ungroupedItems = displayMealDealGroups
    ? mealDealGroups.ungroupedItems
    : basket?.productItems

  useEffect(() => {
    (async function () {
      if (!cms.contentById[GLOBAL_MINI_CART_CONTENT_SLOT]) {
        await cms.fetchItemByKey(GLOBAL_MINI_CART_CONTENT_SLOT)
      }
    })()
  }, [])

  return (
    <Stack flexBasis="full" overflow="auto" spacing="0px" bg="gray25">
      {!basketStore.hasItems && !someItemsUnavailable ? (
        <Stack align="center" justify="center" width="full" height="full" gap="12px">
          <BasketIcon boxSize="36px" style={{color: '#9b9b9b'}} />
          <Text
            variant="unstyled"
            color="textMuted"
            lineHeight="short"
            as="span"
            align="center"
            style={{fontSize: 18, color: '#9b9b9b'}}
          >
            Your basket is <br /> currently empty
          </Text>
        </Stack>
      ) : (
        <>
          {someItemsUnavailable && <UnavailableCartItems inDrawer={true} />}
          {groupedBonusItems?.map((productItem: ProductItem) =>
            productItem.productId ? (
              <FreeGift
                inDrawer={true}
                key={productItem.productId}
                id={productItem.productId}
                name={productItem.productName}
                className={cartItemDrawer}
                quantity={productItem.quantity}
              />
            ) : null
          ) || []}

          {displayMealDealGroups &&
            mealDealGroups?.groupedItems?.map((group: MealDealGroup, idx: number) => (
              <MealDealCartItem
                className={cartItemDrawer}
                inDrawer={true}
                id={`meal-deal-${group.promoID}-${idx}`}
                key={`meal-deal-${group.promoID}-${idx}`}
                group={group}
              />
            ))}

          {ungroupedItems?.map((productItem: ProductItem, idx: number) => {
            const item = displayMealDealGroups ? productItem.item : productItem
            if (!item?.productId) return
            const quantity =
              displayMealDealGroups && productItem?.displayQuantity
                ? productItem?.displayQuantity
                : item.quantity
            return (
              <CartItem
                inDrawer
                key={item.itemId}
                id={item.productId}
                className={cartItemDrawer}
                displayQuantity={quantity}
                borderBottom={idx === (ungroupedItems?.length ?? 0) - 1 ? '0px' : '1px'}
              />
            )
          })}

          {cms.contentById[GLOBAL_MINI_CART_CONTENT_SLOT] && (
            <Slot
              data={cms.contentById[GLOBAL_MINI_CART_CONTENT_SLOT]}
              deliveryKey={cms.contentById[GLOBAL_MINI_CART_CONTENT_SLOT]._meta.deliveryKey}
            />
          )}
        </>
      )}
    </Stack>
  )
})
